import DOMPurify from 'dompurify';
import { type FC } from 'react';

import { cn } from '@/lib/utils';

interface ReleaseNoteDescriptionProps {
  description: string;
  className?: string;
}

const ReleaseNoteDescription: FC<ReleaseNoteDescriptionProps> = ({ description, className }) => {
  const cleanHtml = DOMPurify.sanitize(description);

  return (
    <div
      className={cn(
        'text-sm prose prose-sm [&_ul]:list-disc! [&_em]:[font-synthesis:style]! [&_ul]:pl-5! [&_ul_li::marker]:text-black [&_ol]:list-decimal! [&_ol]:pl-5! [&_ol::marker]:text-black [&_li]:mb-1! break-word',
        className
      )}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default ReleaseNoteDescription;
